import { RestMethod } from "../../_helpers/ApiConfig/RestMethod";
import { USER_DATA_CONSTANT } from "../../_constants/Redux/userData.constant";
import configureStore from "../../redux/Store";
let { Store } = configureStore();
export async function getAllAreaOfOperation(filter) {
  let url = "/global-configuration/ehs-module/area-of-operation?";
  try {
    const areaOfOperationData = Store.getState()?.userManagement?.areaOfOperationData;
    if (Array.isArray(areaOfOperationData) && areaOfOperationData.length === 0) {
      const response = await RestMethod.GET(url);
      Store.dispatch({
        type: USER_DATA_CONSTANT.AREA_OF_OPERATION,
        data: response,
      });
      return response.data;
    } else {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve({
            status: 1,
            message: "Data from store",
            data: areaOfOperationData,
          });
        }, 0);
      });
    }
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

export async function getAreaOfOperationById(id) {
  let url = "/global-configuration/ehs-module/area-of-operation/" + id;

  try {
    const response = await RestMethod.GET(url);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

export async function createAreaOfOperation(data) {
  try {
    const response = await RestMethod.POST(
      "/global-configuration/ehs-module/area-of-operation",
      data
    );
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

export async function updateAreaOfOperation(id, data) {
  try {
    const response = await RestMethod.PUT(
      "/global-configuration/ehs-module/area-of-operation/" + id,
      data
    );
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

export async function deleteAreaOfOperation(id) {
  try {
    const response = await RestMethod.DELETE(
      "/global-configuration/ehs-module/area-of-operation/" + id
    );
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}
